import { Box, Button, Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DropdownComponent from "../../Components/DropdownComponent";
import { JobStatusdetail } from "../../redux/Thunk/ClientModule/ClientThunk";
import {
  getJobSummeryFreelancerByFilter,
  jobSummeryDetailsGet,
} from "../../redux/Thunk/FreelanceScreenThunk/FreelanceThunk";
import GenericTable from "../../Components/Ui_elements/GenericTable";
import { showSnackbar } from "../../redux/Slice/snackbar/snackbarSlice";
import Btn from "../../Components/Ui_elements/Btn";
import PopupModal from "../../Components/Ui_elements/PopupModal";
import JobsPopup from "./JobsPopup";
import { localizeNumber } from "../../Helper/generalhelper";

const FreelanceReports = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.root.authUser);
  const { job_status } = useSelector(state => state.root.ClientModule);
  const { freelance_jobs_report, job_summary } = useSelector(state => state.root.FreelanceModule);
  const [openJob, setOpenJob] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [jobData, setJobData] = useState({});
  const [isChatOpen, setIsChatOpen] = useState(false);

  const [formData, setFormData] = useState({
    item_status: "",
  });

  useEffect(() => {
    dispatch(JobStatusdetail());
  }, []);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const updateSearch = () => {
    const payload = {
      searchValue: formData.item_status,
      user_id: user?.iUserId,
    };
    if (formData.item_status === "") {
      dispatch(
        showSnackbar({
          message: "Please Select Job Status",
          type: "info",
        })
      );
      return;
    }
    dispatch(getJobSummeryFreelancerByFilter(payload));
  };
  const handleDeleteSearch = () => {
    const payload = {
      searchValue: "",
      user_id: "",
    };
    setFormData({ item_status: "" });
    dispatch(getJobSummeryFreelancerByFilter(payload));
  };

  const handleOpenJobsModal = id => {
    setOpenJob(true);
    setJobId(id);
    dispatch(jobSummeryDetailsGet(id));
  };

  const columns = [
    {
      name: "rowNumber",
      label: "#",
      options: { sort: false },
    },
    {
      name: "po_number",
      label: "Job Number",
      options: {
        customBodyRender: (value, tableMeta) => {
          const job_summmeryId = freelance_jobs_report?.data?.[tableMeta.rowIndex]?.job_summmeryId;
          return (
            <Box>
              <Typography
                onClick={() => handleOpenJobsModal(job_summmeryId)}
                variant="body2"
                sx={{ cursor: "pointer", color: "blue" }}
              >
                {value}
              </Typography>
            </Box>
          );
        },
      },
    },
    {
      name: "item_status",
      label: "Status",
    },
    {
      name: "contact_person",
      label: "Contact Persons",
    },
    {
      name: "resource",
      label: "Resource",
    },
    {
      name: "ItemLanguage",
      label: "Target Language",
    },
    {
      name: "total_price",
      label: "Prices",
      options: {
        customBodyRender: value => {
          const amount = Number(value);
          const safeAmount = isNaN(amount) ? 0 : amount;

          return localizeNumber(safeAmount.toFixed(2));
        },
      },
    },
  ];

  const jobassignoptions = job_status.map(option => ({
    value: option.job_status_name,
    label: option.job_status_name,
  }));

  console.log("job_summary ", job_summary);
  return (
    <>
      <Card sx={{ p: 2 }}>
        <Typography variant="body1" mb={1} p={1} sx={{ backgroundColor: "#f4f4fb" }}>
          Select
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <DropdownComponent
              label="Job Status"
              name="item_status"
              value={formData?.item_status}
              onChange={handleInputChange}
              options={jobassignoptions}
              isNotMandatory={true}
            />
          </Grid>

          <Grid item xs={12} md={4} mt={3}>
            <Grid container spacing={2}>
              <Grid item>
                <Button onClick={updateSearch} variant="contained" color="primary">
                  Update Search
                </Button>
              </Grid>
              <Grid item>
                <Button onClick={handleDeleteSearch} variant="contained" color="primary">
                  Delete Search
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
      <CardContent>
        <GenericTable
          columns={columns}
          data={freelance_jobs_report?.data?.map((row, index) => ({
            ...row,
            rowNumber: index + 1,
          }))}
          showAction={false}
          displayColumns={4}
          displayRows={10}
        />
      </CardContent>

      {jobId && (
        <JobsPopup
          jobId={jobId}
          data={job_summary?.data}
          tabValue={0}
          openJob={openJob}
          handleOpenJobDiscussionPage={data => setOpenJob(data)}
          openFromReport={true}
          onRefresh={updateSearch}
        />
      )}
    </>
  );
};

export default FreelanceReports;
